import React, { createContext, useContext, useState, useCallback } from "react";

interface EmailData {
  to?: string;
  subject?: string;
  body?: string;
}

interface EmailContextType {
  openEmail: (data?: EmailData) => void;
  closeEmail: () => void;
  isOpen: boolean;
  emailData: EmailData | null;
}

const EmailContext = createContext<EmailContextType | undefined>(undefined);

export const useEmail = () => {
  const context = useContext(EmailContext);
  if (!context) {
    throw new Error("useEmail must be used within EmailProvider");
  }
  return context;
};

interface EmailProviderProps {
  children: React.ReactNode;
}

export const EmailProvider = ({ children }: EmailProviderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [emailData, setEmailData] = useState<EmailData | null>(null);

  const openEmail = useCallback((data?: EmailData) => {
    setEmailData(data || null);
    setIsOpen(true);
  }, []);

  const closeEmail = useCallback(() => {
    setIsOpen(false);
    // Keep data for animation, clear after
    setTimeout(() => setEmailData(null), 300);
  }, []);

  return (
    <EmailContext.Provider
      value={{
        openEmail,
        closeEmail,
        isOpen,
        emailData,
      }}
    >
      {children}
    </EmailContext.Provider>
  );
};
